<h3
  *ngIf="locationCodesInBound?.length > 0"
  class="flex flex--middle medium-type font-body-1 ms-xsmall-l accommodate-icon"
>
  <span>
    <ng-container>
      {{ 'MMB.includedProducts.cabinBaggage.boundHeader.' + flightHeader + '.title' | finLocalization }}
    </ng-container>

    <ng-container> - </ng-container>
    <ng-container *ngFor="let locationCodes of locationCodesInBound; last as isLastFlight">
      <ng-container *ngFor="let code of locationCodes; last as isLastLocation">
        {{ getCityName(code, locations) | titlecase }}
        <ng-container *ngIf="!isLastLocation"> - </ng-container>
      </ng-container>
      <ng-container *ngIf="!isLastFlight">, </ng-container>
    </ng-container>
  </span>
  <ng-content></ng-content>
</h3>
